/**
 * One formatter for all euro amounts. toLocaleString with options builds a new Intl.NumberFormat on every call:
 * the prices and delivery methods of a product page took ~150 ms of a phone's main thread (mobiilinopeus 4.11.2026).
 */
export const euroFormat = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' })

export const formatPrice = (price: string | number): string => euroFormat.format(parseFloat(`${price}`))
export const calculateDiscountPercent = (price: number, finalPrice: number): number => Math.round(100 - ((finalPrice / price) * 100))
